




























import Vue from 'vue';
import HeadLine from '../atoms/HeadLine.vue';
import ContentTitle from '../atoms/ContentTitle.vue';
import BaseText from '../atoms/BaseText.vue';

export default Vue.extend({
  components: {
    HeadLine,
    ContentTitle,
    BaseText
  },
  props: {
    content: {
      type: Object,
      required: true
    },
    subjectName: {
      type: String,
      required: true
    },
    clickable: {
      type: Boolean,
      required: true
    },
    icons: {
      type: Object,
      required: true
    }
  },
  methods: {
    showMovie(filename: string): void {
      this.$store.commit('SET_MOVIE_FILE_NAME', { filename: filename })
      this.$router.push('/play_video')
    }
  }
})
